module.exports = __webpack_public_path__ + "img/opp-running-calc.db26fd54.png";